import HCaptcha from "@hcaptcha/react-hcaptcha";
import { useRef } from "react";

interface ReCaptchaProps {
  sitekey: string;
  next: () => void;
}

const ReCaptcha: React.FC<ReCaptchaProps> = ({ sitekey, next }) => {
  const captchaRef = useRef<any>(null);

  const onVerify = (token: string) => {
    next();
  };

  return (
    <div
      // style={{
      //   transform: "scale(0.85)",
      //   transformOrigin: "0 0",
      // }}
    >
      <HCaptcha sitekey={sitekey} onVerify={onVerify} ref={captchaRef} />
    </div>
  );
};

export default ReCaptcha;
